import JChartTableSummary from './Control_Tables'
export { JChartTableSummary }
export default JChartTableSummary